import Spinner from '@/common/components/Spinner';

const OAuthLoading = () => {
  return (
    <div className='flex flex-col items-center justify-center gap-8 h-96'>
      <Spinner className='text-white-400 size-12' />

      <div className='flex flex-col items-center gap-2'>
        <p className='text-xl font-medium'>
          Autenticando...
        </p>

        <p className='italic font-light'>
          Estamos verificando suas credenciais. Isso pode levar alguns segundos.
        </p>
      </div>
    </div>
  )
}

export default OAuthLoading;
